/**
 * Central icon registry. Always reference icons from here rather than
 * inlining raw Iconify strings throughout the codebase.
 */
const ICONS = {
  // File / document actions
  UPLOAD: "material-symbols:upload-rounded",
  EDIT: "material-symbols:edit-square-outline-rounded",
  DOWNLOAD: "material-symbols:download",
  ATTACHMENT: "mdi:paperclip",

  // Delete / remove
  /** Primary delete CTA — trash can with ✕ (e.g. delete-entry buttons) */
  DELETE: "tabler:trash-x-filled",
  /** Compact trash — used in small badge/inline contexts */
  TRASH: "mdi:trash",
  /** Inline remove chip — ✕ circle next to a list item */
  REMOVE: "mdi:close-circle-outline",

  // View / status
  VIEW: "solar:eye-bold",
  CHECK: "fa:check",
  INFO: "material-symbols:info-outline",
  LOADING: "line-md:loading-loop",

  // Navigation
  CHEVRON_LEFT: "mdi:chevron-left",
  CHEVRON_RIGHT: "mdi:chevron-right",
  CHEVRON_DOWN: "mdi:chevron-down",
  ARROW_LEFT: "lucide:arrow-left",

  // Calendar
  CALENDAR: "uil-calendar",
} as const;

export default ICONS;
